import { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import _ from 'lodash';
import { Box, Typography, FormControlLabel, Checkbox, Grid } from '@mui/material';
import DeleteIcon from '../../../../../asset/image/delete2.svg';
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";



import {
  getWanProfileDetailsData,
  getWanProfilesData,
  updateWanProfileData,
  createWanProfileData,
  getUnusedWanInterfacesData,
  deleteWanProfileData,
  getDeviceLinkStatusData,
  geteAllWanInterfacesForAdvSettingsData,
  getIpConfigUpdateData
} from '../../../../../actions/Users/authenticateOpenEdgeService';
import { GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS, GET_IP_CONFIG_UPDATE } from '../../../../../actions/types';

import WanProfileDropdown from '../../components/WANProfileDropdown/WanProfileDropdown';
import AddButton from '../../components/AddButton/AddButton';
import AdvancedWANConfigurator from '../../components/AdvancedWANConfigurator/AdvancedWANConfigurator';
import DeleteWANProfileModal from '../../components/Modals/DeleteProfileModal';

import './WanTab.css';
import CustomLoader from '../../../../../components/Loader/CustomLoader';
import { getDataFromLocalStorage, isLicenseTierIn, isVersionLessThanEqual } from '../../../../../utils/util';
import TabsComponent from '../../../../../components/NewTabs';
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from '../../components/InterfacesTable/NetworkTable/NetworkTable';
import AddEditInterfaceModal from '../../components/Modals/AddEditInterfaceModal';
import PolicyRoutes from './PolicyRoutes/PolicyRoutes';
import LabelValueDisplay from '../../components/LabelValue/LabelValueDisplay';
import { validateIp, ipv4Regex, cidrToNetmask, netmaskToCIDR } from "../../../../../utils/util";
import { Netmask } from 'netmask';
import { useConfigAutoRefresh } from "../../hooks/useConfigAutoRefresh";

type FullWanProfile = {
  id: number;
  profileName: string;
  DID: string;
  sys_profile?: boolean
};

type DropdownWanProfile = {
  id: string;
  name: string;
};

type WanLink = {
  id: string;
  name: string;
  percentage?: number;
  wan_link_type?: string;
};

type WANTabProps = {
  row: any;
  wanRef?: React.MutableRefObject<any>;
  getWanProfilesData: (deviceId: string, isEanbled?: boolean, silent?: boolean) => void;
  getWanProfileDetailsData: (profileId: string, deviceId: string, silent?: boolean) => void;
  updateWanProfileData: (payload: any) => Promise<any>;
  createWanProfileData: (payload: any) => Promise<any>;
  getUnusedWanInterfacesData: (deviceId: string, profileId: string, silent?: boolean) => Promise<any>;
  deleteWanProfileData: (profileId: number, deviceId: string) => Promise<any>;
  getWanProfiles: any;
  getWanProfileDetails: any;
  rememberedProfileId?: string | null;
  setRememberedProfileId?: (id: string | null) => void;

  redirectProfileId?: string;
  setRedirectProfileId?: (id: string | null) => void;
  setHasUnsavedChanges?: (val: boolean) => void;

  setProfileSwitched?: (val: boolean) => void;
  setNewProfileCreated?: (val: boolean) => void;
  modalOpenCount: number;
  forceRemountWANTab: () => void;

  savedTempProfilesRef: React.MutableRefObject<Set<string>>;
  deviceInfo?: String;
  refreshIconClicked?: boolean;
  deviceLinkStatusLoading: boolean;
  getDeviceLinkStatusData: (k4Id: string, deviceId: string, silent?: boolean) => void;
  geteAllWanInterfacesForAdvSettingsData: (deviceId: string, silent?: boolean) => void;
  geteAllWanInterfacesForAdvSettings: any;
  geteAllWanInterfacesForAdvSettingsLoading: boolean;
  getIpConfigUpdateData: (payload: any) => void;
  getIpConfigUpdate: any;
  getIpConfigUpdateLoading: boolean;
  redirectedTab?: any;
  setShowFooter?: (val: boolean) => void;
  notifyConfigAction?: () => void;
  notifyConfigActionComplete?: () => void;
};

function WANTab({
  row,
  wanRef,
  rememberedProfileId,
  setRememberedProfileId,
  getWanProfilesData,
  getWanProfileDetailsData,
  updateWanProfileData,
  createWanProfileData,
  getUnusedWanInterfacesData,
  deleteWanProfileData,
  getWanProfiles,
  getWanProfileDetails,
  redirectProfileId,
  setRedirectProfileId,
  setHasUnsavedChanges,
  setProfileSwitched,
  setNewProfileCreated,
  modalOpenCount,
  forceRemountWANTab,
  savedTempProfilesRef,
  deviceInfo,
  refreshIconClicked,
  deviceLinkStatusLoading,
  getDeviceLinkStatusData,
  geteAllWanInterfacesForAdvSettingsData,
  geteAllWanInterfacesForAdvSettings,
  geteAllWanInterfacesForAdvSettingsLoading,
  getIpConfigUpdateData,
  getIpConfigUpdate,
  getIpConfigUpdateLoading,
  redirectedTab,
  setShowFooter,
  notifyConfigAction,
  notifyConfigActionComplete,
}: WANTabProps) {
  const [wanProfiles, setWanProfiles] = useState<FullWanProfile[]>([]);
  const [selectedProfile, setSelectedProfile] = useState<FullWanProfile | null>(null);
  const [unusedLinks, setUnusedLinks] = useState<WanLink[]>([]);
  const [localBondingData, setLocalBondingData] = useState<any[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isRenaming, setIsRenaming] = useState(false);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [deleteError, setDeleteError] = useState<string>('');
  const [tempProfileName, setTempProfileName] = useState<string>("");
  const [activeTab, setActiveTab] = useState(redirectedTab ? redirectedTab : 'profiles');


  const suppressNextFetchRef = useRef(false);
  const newProfileIdRef = useRef<string | null>(null);

  const originalBondingRef = useRef<any[]>([]);

  const previousProfileIdRef = useRef<string | null>(null);

  const hasProfileSwitchUnsavedRef = useRef(false);

  const isNewProfileUnsavedRef = useRef(false);
  const bondingDataCacheRef = useRef<Map<string, any[]>>(new Map());

  const didInitialFetchRef = useRef(false);

  const shouldFetchWanDataRef = useRef(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [columns, setColumns] = useState<ColumnConfig[]>([
    {
      label: "Wan Alias",
      key: "alias",
      type: ColumnType.text,
      maxWidth: "41px",
    },
    {
      label: "Interface Name",
      key: "primary_interface",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Address Type",
      key: "proto",
      type: ColumnType.boolean,
      maxWidth: "63px",
      booleanList: ["DHCP", "Static IP"]
    },
    {
      label: "Interface IP / Subnet",
      key: "interface_ip",
      type: ColumnType.combinedColumn,
      maxWidth: "151px",
      combinedColumnList: ["ipaddr", "netmask"],
      columnListSeperator: " / "
    },
    {
      label: "Gateway Address",
      key: "gateway",
      type: ColumnType.text,
      maxWidth: "151px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      maxWidth: "68px",
      actions: ["setting"]
    }
  ])
  const [tableData, setTableData] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState<any>({});
  const [ipError, setIpError] = useState("");
  const [gatewayError, setGatewayError] = useState("");
  const dispatch = useDispatch();

  const fetchTableData = () => {
    switch (activeTab) {
      case 'ip_configuration': {
        geteAllWanInterfacesForAdvSettingsData(row?.['deviceId']);
        break;
      }
    }
  }

  // Skip the very first firing (tab mount) of the interfaces-status call:
  // InventoryPopup's centralized effect already refreshes it once when this
  // tab opens. Subsequent firings (sub-tab clicks, manual refresh) still call
  // it, since interfaces status is device-wide, not tied to one sub-tab.
  const skipFirstLinkStatusFetchRef = useRef(true);
  useEffect(() => {
    fetchTableData();
    if (skipFirstLinkStatusFetchRef.current) {
      skipFirstLinkStatusFetchRef.current = false;
    } else {
      getDeviceLinkStatusData(row['k4Id'], row['deviceId']);
    }
  }, [activeTab, refreshIconClicked])

  // IP Configuration and Policy Routes are both saved from their own
  // Add/Edit dialogs, so the modal-level Save footer (which only pushes WAN
  // Profile bonding/rename drafts via saveWanProfileConfig) does not apply
  // there - only WAN Profiles has anything for it to save.
  useEffect(() => {
    setShowFooter?.(activeTab === 'profiles');
  }, [activeTab])

  // Same data the manual refresh button re-fetches for whichever sub-tab is
  // active, on a 30s idle baseline (immediate on mount/tab switch too), sped
  // up to 2s during an in-flight config change via startAction()/stopAction()
  // below. Profile-detail refetching is already guarded downstream against
  // clobbering unsaved local edits (see the `wan_unsaved_*` checks).
  // Interfaces status itself is refreshed centrally (InventoryPopup) and via
  // the sub-tab-switch effect above, not duplicated here.
  const wanAutoRefresh = useConfigAutoRefresh({
    fetchFns: [
      (silent) => {
        if (activeTab === 'ip_configuration') {
          geteAllWanInterfacesForAdvSettingsData(row?.['deviceId'], silent);
        } else if (activeTab === 'profiles' && selectedProfile) {
          getWanProfilesData(row.deviceId, false, silent);
          getWanProfileDetailsData(String(selectedProfile.id), row.deviceId, silent);
          getUnusedWanInterfacesData(row.deviceId, String(selectedProfile.id), silent);
        }
      },
    ],
    enabled: !!row?.deviceId,
  });

  useEffect(() => {
    if (!_.isEmpty(geteAllWanInterfacesForAdvSettings)) {
      const res = geteAllWanInterfacesForAdvSettings.hasOwnProperty('interfaces') ? geteAllWanInterfacesForAdvSettings?.interfaces : [];
      setTableData(res);
      dispatch({ type: GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS, payload: {} })
    }

    // if (_.isEmpty(getEnableDisableNoNat)) return;
    // if (getEnableDisableNoNat.status === true) {
    //   fetchTableData();
    //   dispatch({ type: GET_ENABLE_DISABLE_NO_NAT, payload: {} });
    // } else {
    //   setTableData((prev) =>
    //     prev.map((item) =>
    //       item.id === row.id ? { ...item, active: row.active } : item
    //     )
    //   );
    //   dispatch({ type: GET_ENABLE_DISABLE_NO_NAT, payload: {} });
    // }
  }, [geteAllWanInterfacesForAdvSettings])

  useEffect(() => {
    if (wanRef) {
      wanRef.current = {
        saveWanProfileConfig: async () => {
          if (!row?.deviceId) return;

          const unsavedKeys = Object.keys(localStorage).filter(
            key => key.startsWith("wan_unsaved_") && localStorage.getItem(key) === "true"
          );

          const renameMapRaw = localStorage.getItem('wanRenamedProfilesCache');
          const renameMap = renameMapRaw ? new Map(Object.entries(JSON.parse(renameMapRaw))) : new Map();

          for (const [id] of Array.from(renameMap.entries())) {
            if (!unsavedKeys.includes(`wan_unsaved_${id}`)) {
              unsavedKeys.push(`wan_unsaved_${id}`);
            }
          }

          if (selectedProfile) {
            const currentId = String(selectedProfile.id);
            if (
              localStorage.getItem(`wan_unsaved_${currentId}`) === "true" ||
              renameMap.has(currentId)
            ) {
              if (!unsavedKeys.includes(`wan_unsaved_${currentId}`)) {
                unsavedKeys.push(`wan_unsaved_${currentId}`);
              }
            }
          }

          if (unsavedKeys.length === 0) {
            return;
          }

          const profilesPayload: any[] = [];
          const alreadySavedIds = new Set<string>();

          for (const key of unsavedKeys) {
            const profileId = key.replace("wan_unsaved_", "");
            if (alreadySavedIds.has(profileId)) continue;

            const bondingJson = localStorage.getItem(`bondingData_${profileId}`);
            const bondingData = bondingJson ? JSON.parse(bondingJson) : [];

            const matchedProfile = getWanProfiles?.wan_profiles.find(p => String(p.id) === profileId);
            const isTemporary = profileId.startsWith("temp-");

            const renamedName =
              renameMap.get(profileId) ||
              matchedProfile?.profileName ||
              localStorage.getItem(`wanNewProfileName_${profileId}`) ||
              "Unnamed";

            const profilePayload: any = {
              action: isTemporary ? "create" : "update",
              profileName: renamedName,
              enabledWans: bondingData.map(link => ({
                interfaceName: link.interfaceName,
                weight: String(link.weight),
                priority: String(link.priority),
                wan_id: link.wan_id,
                wan_link_type: link.wan_link_type || "",
              })),
            };

            if (!isTemporary) {
              profilePayload.id = matchedProfile?.id;
            }

            profilesPayload.push(profilePayload);
            alreadySavedIds.add(profileId);
          }

          if (profilesPayload.length === 0) return;

          const finalPayload = {
            data: {
              profiles: profilesPayload,
              userName: getDataFromLocalStorage("loggedInEmail"),
              k4Id: row?.k4Id,
              DID: row.deviceId,
            },
          };

          wanAutoRefresh.startAction();
          notifyConfigAction?.();
          try {
            const result = await updateWanProfileData(finalPayload);
            if (result?.status) {
              for (const key of unsavedKeys) {
                const profileId = key.replace("wan_unsaved_", "");
                localStorage.removeItem(`wan_unsaved_${profileId}`);
                localStorage.removeItem(`bondingData_${profileId}`);
                localStorage.removeItem(`unusedWanLinks_${profileId}`);
                localStorage.removeItem(`wanNewProfileName_${profileId}`);
                renameMap.delete(profileId);
                bondingDataCacheRef.current.delete(profileId);
              }
              localStorage.removeItem('wanRenamedProfilesCache');

              setHasUnsavedChanges?.(false);
              setProfileSwitched?.(false);
              setNewProfileCreated?.(false);
              hasProfileSwitchUnsavedRef.current = false;
              isNewProfileUnsavedRef.current = false;

              await getWanProfilesData(row.deviceId, false);
              // forceRemountWANTab?.();
            }
          } catch (err) {
            console.error("Bulk save failed", err);
          } finally {
            wanAutoRefresh.stopAction();
            notifyConfigActionComplete?.();
          }
        },

        getHasUnsavedChanges: () =>
          hasProfileSwitchUnsavedRef.current || isNewProfileUnsavedRef.current || false,
      };
    }
  }
    , [selectedProfile, localBondingData, row?.deviceId]);


  useEffect(() => {
    if(activeTab != 'profiles') return;
    if (row?.deviceId && !suppressNextFetchRef.current) {
      getWanProfilesData(row.deviceId, false);
    }
    suppressNextFetchRef.current = false;
  }, [row, refreshIconClicked, activeTab]);

  useEffect(() => {
    if (!originalBondingRef.current) return;

    const hasChanged = !_.isEqual(
      _.sortBy(localBondingData, ['interfaceName', 'priority']),
      _.sortBy(originalBondingRef.current, ['interfaceName', 'priority'])
    );

    setHasUnsavedChanges?.(hasChanged);
  }, [localBondingData]);


  useEffect(() => {
    const data = getWanProfiles?.status ? getWanProfiles.wan_profiles : [];


    const renameMapRaw = localStorage.getItem('wanRenamedProfilesCache');
    const renameMap = renameMapRaw ? new Map(Object.entries(JSON.parse(renameMapRaw))) : new Map();


    const tempProfiles = Object.keys(localStorage)
      .filter(k => k.startsWith("wanNewProfileName_"))
      .map(k => {
        const tempId = k.replace("wanNewProfileName_", "");
        const renamed = renameMap.get(tempId);
        return {
          id: tempId as unknown as number,
          profileName: renamed || localStorage.getItem(k) || "Unnamed",
          DID: row.deviceId,
        };
      });

    const overriddenProfiles = [
      ...data.map(profile => {
        const renamed = renameMap.get(String(profile.id));
        return renamed ? { ...profile, profileName: renamed } : profile;
      }),
      ...tempProfiles,
    ];

    setWanProfiles(overriddenProfiles);


    const forceProfileName = sessionStorage.getItem("forceSelectProfileName");

    let matched: FullWanProfile | undefined = undefined;

    if (forceProfileName) {
      matched = overriddenProfiles.find(p => p.profileName === forceProfileName);
      sessionStorage.removeItem("forceSelectProfileName");
    }

    if (!matched && redirectProfileId) {
      matched = overriddenProfiles.find(p => p.profileName === redirectProfileId);
      setRedirectProfileId?.(null);
    }

    if (!matched && rememberedProfileId) {
      matched = overriddenProfiles.find(p => String(p.id) === rememberedProfileId);
    }

    const fallback = matched || overriddenProfiles[0];
    if (fallback) {
      setSelectedProfile(fallback);
      setRememberedProfileId?.(String(fallback.id));
      sessionStorage.setItem("wanProfileId", String(fallback.id));
    }
  }, [getWanProfiles]);


  const hasFetchedOnceRef = useRef(false);


  useEffect(() => {
    if (!selectedProfile || !row?.deviceId) return;

    const profileId = String(selectedProfile.id);


    if (hasFetchedOnceRef.current) {
      return;
    }

    hasFetchedOnceRef.current = true;




    setIsLoadingProfile(true);
    setLocalBondingData([]);
    setUnusedLinks([]);


    const localUnsaved = localStorage.getItem(`wan_unsaved_${profileId}`) === "true";
    const cachedBonding = localStorage.getItem(`bondingData_${profileId}`);
    const cachedUnused = localStorage.getItem(`unusedWanLinks_${profileId}`);

    if (localUnsaved && cachedBonding && cachedUnused) {

      const bonding = JSON.parse(cachedBonding);
      const unused = JSON.parse(cachedUnused);

      setLocalBondingData(bonding);
      setUnusedLinks(unused);

      setIsLoadingProfile(false);
      setHasUnsavedChanges?.(true);
      return;
    }


    Promise.all([
      getWanProfileDetailsData(profileId, row.deviceId),
      getUnusedWanInterfacesData(row.deviceId, profileId)
    ])
      .then(([_, res]) => {
        if (res?.data?.interfaces) {
          const formatted = res.data.interfaces.map((item) => ({
            ...item,
            id: String(item.id),
            name: item.alias,
            wan_link_type: item.wan_link_type,
          }));
          handleUnusedLinksChange(formatted);
        }
      })
      .finally(() => {
        setIsLoadingProfile(false);
      });

  }, [selectedProfile?.id, row?.deviceId]);




  useEffect(() => {
    const profileId = String(selectedProfile?.id || "");
    const apiProfile = getWanProfileDetails?.wan_profile;

    const enabledWans = apiProfile?.enabledWans;
    const responseProfileId = apiProfile?.id;

    if (!enabledWans || String(responseProfileId) !== String(profileId)) {
      return;
    }

    const isUnsaved = localStorage.getItem(`wan_unsaved_${profileId}`) === "true";

    if (isUnsaved) {
      return;
    }

    const cloned = JSON.parse(JSON.stringify(enabledWans));
    setLocalBondingData(cloned);
    originalBondingRef.current = cloned;
    bondingDataCacheRef.current.set(profileId, cloned);

    setHasUnsavedChanges?.(false);
    hasProfileSwitchUnsavedRef.current = false;
    isNewProfileUnsavedRef.current = false;
  }, [getWanProfileDetails?.wan_profile, selectedProfile?.id]);


  useEffect(() => {
    if(activeTab != 'profiles') return;
    if (!selectedProfile || !row?.deviceId) {
      console.warn('[WANTab] Remount skipped: no selectedProfile or deviceId');
      return;
    }

    const profileId = String(selectedProfile.id);


    setIsLoadingProfile(true);
    setLocalBondingData([]);
    setUnusedLinks([]);

    Promise.all([
      getWanProfileDetailsData(profileId, row.deviceId),
      getUnusedWanInterfacesData(row.deviceId, profileId)
    ])
      .then(([_, unusedRes]) => {
        if (unusedRes?.data?.interfaces) {
          const formatted = unusedRes.data.interfaces.map((item: any) => ({
            ...item,
            id: String(item.id),
            name: item.alias,
            wan_link_type: item.wan_link_type,
          }));
          handleUnusedLinksChange(formatted);
        }
      })
      .catch(err => {
        console.error('[WANTab] Failed to refetch WAN profile data after remount:', err);
      })
      .finally(() => {
        setIsLoadingProfile(false);
      });
  }, [modalOpenCount, refreshIconClicked, activeTab]);




  useEffect(() => {
    console.log("API response received:", getWanProfileDetails?.wan_profile);
    console.log("selectedProfile.id:", selectedProfile?.id);
  }, [getWanProfileDetails?.wan_profile, selectedProfile?.id]);


 const handleProfileChange = (profile: DropdownWanProfile) => {
  if (String(selectedProfile?.id) === profile.id) return;

  const matched = wanProfiles.find(p => String(p.id) === profile.id);
  if (matched) {
    const profileId = profile.id;

    hasFetchedOnceRef.current = false;
    setIsLoadingProfile(true);
    setLocalBondingData([]);
    setUnusedLinks([]);
    setSelectedProfile(matched);
    setRememberedProfileId?.(String(profileId));

    hasProfileSwitchUnsavedRef.current = false;
    isNewProfileUnsavedRef.current = false;
    setHasUnsavedChanges?.(false);

    bondingDataCacheRef.current.delete(profileId);

    setIsRenaming(false);

    const hasUnsaved = localStorage.getItem(`wan_unsaved_${profileId}`) === "true";
    if (!hasUnsaved) {
      localStorage.removeItem(`bondingData_${profileId}`);
      localStorage.removeItem(`unusedWanLinks_${profileId}`);
      localStorage.removeItem(`wan_unsaved_${profileId}`);
    }
  }
};


  const dropdownProfiles: DropdownWanProfile[] = wanProfiles.map(p => ({
    id: String(p.id),
    name: p.profileName,
  }));

  const handleProfileEdit = async (updated: DropdownWanProfile) => {
    setIsRenaming(true);

    const updatedList = wanProfiles.map(p =>
      String(p.id) === updated.id ? { ...p, profileName: updated.name } : p
    );
    setWanProfiles(updatedList);

    const matched = updatedList.find(p => String(p.id) === updated.id);
    if (matched) setSelectedProfile(matched);

    const renamedMapRaw = localStorage.getItem('wanRenamedProfilesCache');
    const renamedMap = renamedMapRaw ? new Map(Object.entries(JSON.parse(renamedMapRaw))) : new Map();
    renamedMap.set(updated.id, updated.name);
    localStorage.setItem('wanRenamedProfilesCache', JSON.stringify(Object.fromEntries(renamedMap)));


    const profileId = updated.id;
    localStorage.setItem(`bondingData_${profileId}`, JSON.stringify(localBondingData));
    localStorage.setItem(`wan_unsaved_${profileId}`, "true");

    setHasUnsavedChanges?.(true);
    setProfileSwitched?.(false);
    isNewProfileUnsavedRef.current = true;

    setTimeout(() => setIsRenaming(false), 1200);
  };




  const handleBondingChange = (updated: any[]) => {
    setLocalBondingData(updated);
    setHasUnsavedChanges?.(true);
    hasProfileSwitchUnsavedRef.current = true;

    const profileId = String(selectedProfile?.id || "");
    localStorage.setItem(`bondingData_${profileId}`, JSON.stringify(updated));
    localStorage.setItem(`wan_unsaved_${profileId}`, "true");
  };

  const handleUnusedLinksChange = (updated: WanLink[]) => {
    setUnusedLinks(updated);

    const profileId = String(selectedProfile?.id || "");
    localStorage.setItem(`unusedWanLinks_${profileId}`, JSON.stringify(updated));
  };





  const handleCreateProfile = async () => {
    if (!row?.deviceId) return;

    const name = `Profile_${Math.floor(Math.random() * 10000)}`;
    const tempId = `temp-${Date.now()}`;

    const newProfile: FullWanProfile = {
      id: tempId as unknown as number,
      profileName: name,
      DID: row.deviceId,
    };

    const updatedProfiles = [...wanProfiles, newProfile];
    setWanProfiles(updatedProfiles);
    setSelectedProfile(newProfile);

    setLocalBondingData([]);
    setUnusedLinks([]);
    originalBondingRef.current = [];
    bondingDataCacheRef.current.delete(tempId);
    hasFetchedOnceRef.current = true;
    shouldFetchWanDataRef.current = false;

    localStorage.setItem(`wan_unsaved_${tempId}`, "true");
    localStorage.setItem(`wanNewProfileName_${tempId}`, name);
    localStorage.setItem(`bondingData_${tempId}`, JSON.stringify([]));

    newProfileIdRef.current = tempId;
    isNewProfileUnsavedRef.current = true;
    setNewProfileCreated?.(true);

    setRememberedProfileId?.(tempId);
    sessionStorage.setItem("wanProfileId", tempId);

    try {
      const res = await getUnusedWanInterfacesData(row.deviceId, "0");

      if (res?.data?.interfaces) {
        const formatted = res.data.interfaces.map((item: any) => ({
          ...item,
          id: String(item.id),
          name: item.alias,
          wan_link_type: item.wan_link_type,
        }));

        setUnusedLinks(formatted);
        localStorage.setItem(`unusedWanLinks_${tempId}`, JSON.stringify(formatted));
      } else {
        console.warn("No unused WAN interfaces received for new profile.");
      }
    } catch (err) {
      console.error("Failed to fetch unused WAN interfaces:", err);
    }
  };







  const handleDeleteProfile = async (profileId: number | string) => {
    if (!row?.deviceId) return;

    const idStr = String(profileId);
    const isTemp = idStr.startsWith("temp-");

    if (isTemp) {
      console.log("Deleting locally created (unsaved) WAN profile:", profileId);


      localStorage.removeItem(`wan_unsaved_${idStr}`);
      localStorage.removeItem(`wanNewProfileName_${idStr}`);
      localStorage.removeItem(`bondingData_${idStr}`);
      localStorage.removeItem(`unusedWanLinks_${idStr}`);
      
      const renameMapRaw = localStorage.getItem("wanRenamedProfilesCache");
      if (renameMapRaw) {
        const renameMap = JSON.parse(renameMapRaw);
        if (renameMap[idStr]) {
          delete renameMap[idStr];
          if (Object.keys(renameMap).length > 0) {
            localStorage.setItem("wanRenamedProfilesCache", JSON.stringify(renameMap));
          } else {
            localStorage.removeItem("wanRenamedProfilesCache");
          }
        }
      }


      const filtered = wanProfiles.filter(p => String(p.id) !== idStr);
      setWanProfiles(filtered);


      setSelectedProfile(filtered[0] || null);
      setRememberedProfileId?.(filtered[0]?.id ? String(filtered[0].id) : null);
      sessionStorage.setItem("wanProfileId", filtered[0]?.id ? String(filtered[0].id) : "");

      bondingDataCacheRef.current.delete(idStr);
      originalBondingRef.current = [];
      hasFetchedOnceRef.current = false;
      setIsDeleteModalOpen(false);

      return;
    }


    wanAutoRefresh.startAction();
    notifyConfigAction?.();
    const response = await deleteWanProfileData(Number(profileId), row.deviceId);
    wanAutoRefresh.stopAction();
    notifyConfigActionComplete?.();

    if (response?.status && response?.data?.status == true) {
      await getWanProfilesData(row.deviceId, false);

      const updatedProfiles = getWanProfiles?.wan_profiles || [];

      if (updatedProfiles.length > 0) {
        const fallback = updatedProfiles[0];

        setLocalBondingData([]);
        setUnusedLinks([]);
        bondingDataCacheRef.current.delete(String(fallback.id));
        originalBondingRef.current = [];

        hasFetchedOnceRef.current = false;
        setSelectedProfile(fallback);
        setRememberedProfileId?.(String(fallback.id));
      } else {
        setSelectedProfile(null);
        setRememberedProfileId?.(null);
      }
      setIsDeleteModalOpen(false);
    } else {
      setDeleteError(response?.data?.msg);
    }
  };

  // Policy Routes point traffic at a VPN tunnel, so they follow the VPN tab: not
  // offered on the Essential (T101) or Standard AP (T103) licenses, or below v2.0.0.492.
  const tabs = [
    { tabName: 'WAN Profiles', tabValue: 'profiles', pathName: '/inventory' },
    { tabName: 'IP Configuration', tabValue: 'ip_configuration', pathName: '/inventory' },
    { tabName: 'Policy Routes', tabValue: 'policy_routes', pathName: '/inventory' },
  ].filter(({ tabValue }) => {
    if (tabValue === 'policy_routes') {
      return !isLicenseTierIn(row, ['T101', 'T103'])
        && !!row?.['current_EOS_version']
        && isVersionLessThanEqual('v2.0.0.492', row['current_EOS_version']);
    }
    return true;
  });

  const doNavigateTab = (pathname, tabName) => {
    setActiveTab(tabName);
  }

  const handleClosePopup = () => {
    setIsModalOpen(false);
    dispatch({ type: GET_IP_CONFIG_UPDATE, payload: {} })
    setIpError('');
    setGatewayError('');
  }

  const getIpPlusOne = (ip: string) => {
      const parts = ip.split('.').map(Number);
      parts[3] += 1;
      return parts.join('.');
    };

  const handleChange = (key: string) => (e: any) => {
    const value = key === "proto" ? e.target.checked : e.target.value;
    setFormData((prev) => ({
      ...prev,
      [key]: value
    }));
    if (key === "ipaddr") {
      const trimmed = value.trim();
      const [ipRaw, cidrRaw] = trimmed.split("/");
      const ip = ipRaw?.trim();
      const cidr = cidrRaw?.trim();

      let error = "";

      if (!ipv4Regex.test(ip)) {
        error = "Invalid IP address format.";
      } else if (!cidr) {
        error = "Subnet (e.g. /24) is required.";
      } else if (cidr !== undefined) {
        const cidrNum = Number(cidr);
        if (
          isNaN(cidrNum) || cidrNum < 1 || cidrNum > 32 || !Number.isInteger(cidrNum)
        ) {
          error = "CIDR must be a number between 0 and 32.";
        } else {
          const interfaceIp = `${ip}/${cidrNum}`;
          const block = new Netmask(interfaceIp);
          const ipPoolStart = getIpPlusOne(ip);
          const ipPoolEnd = block.last;
          const autoGeneratedIpPools = `${ipPoolStart}-${ipPoolEnd}`;

          setFormData((prev) => ({
            ...prev,
            interface_ip: interfaceIp,
            dhcp_gateway: ip,
            ip_pools: autoGeneratedIpPools,
          }));
        }
      }
      setIpError(error);
    }
    if (key === "gateway") {
      const error = validateIp(value);
      if (error) {
        setGatewayError(error);
      } else {
        setGatewayError("");
      }
    }
    if(key == 'proto' && value) {
      setIpError('');
      setGatewayError('');
    }
  };

  const handleActionClick = (
      type: "setting" | "delete" | "edit",
      headerKey: string,
      row: NetworkTableRow
    ) => {
      console.log(`Action "${type}" clicked on ${headerKey}`, row);
      switch (type) {
        case "setting":
          setIsModalOpen(true);
          setFormData({
            id: row['id'],
            proto: row['proto'],
            ipaddr: row["ipaddr"] && row?.["netmask"] ? `${row["ipaddr"]}/${netmaskToCIDR(row?.["netmask"])}` : '',
            gateway: row['gateway'],
            netmask: row['netmask'],
            interface_type_tmp: row['interface_type_tmp']
          })
          break;
        default:
          console.warn(`Unhandled action type: ${type}`);
      }
    };

  const handleUpdateIpConfig = () => {
    let interface_ip = formData.ipaddr?.trim();
    let netmask = formData.netmask;

    if (interface_ip?.includes('/')) {
      const [ip, cidr] = interface_ip.split('/');
      interface_ip = ip.trim();
      netmask = cidrToNetmask(Number(cidr.trim()));
    }

    const payload = {
      DID: row['deviceId'],
      id: formData['id'],
      proto: formData?.proto,
      ipaddr: interface_ip,
      netmask: netmask,
      gateway: formData?.gateway,
      interface_type_tmp: formData?.interface_type_tmp
    };
    wanAutoRefresh.startAction();
    notifyConfigAction?.();
    getIpConfigUpdateData(payload);
  };

  useEffect(() => {
    if (!_.isEmpty(getIpConfigUpdate)) {
      wanAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if(!_.isEmpty(getIpConfigUpdate) && getIpConfigUpdate?.status) {
      dispatch({ type: GET_IP_CONFIG_UPDATE, payload: {} })
      setIsModalOpen(false);
      setFormData({});
      geteAllWanInterfacesForAdvSettingsData(row?.['deviceId']);
    }
  }, [getIpConfigUpdate])

  const isFormValid = (): boolean => {
    if (!formData) return false;
    const { ipaddr, gateway, proto } = formData;
    if (!proto) {
      if (!ipaddr || !gateway) {
        return false;
      }
      if (ipError || gatewayError) {
        return false;
      }
    }
    return true;
  };

  return (
    <div className="tab-content2">
      <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} isSubTabs={true} removemarginTop={true} />
      {activeTab == 'profiles' && <div className="wan-tab-grid-container" style={{ display: "flex",  flexDirection: "row",  flexWrap: "wrap", }}>

        <Box
          className="wan-tab-grid-container wantab-left-panel"
          sx={{
            minWidth: "200px",            
            borderRight: "1px solid #e0e0e0",
            border: "1px solid #d1d5db",
            padding: "12px",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            backgroundColor: "#f9f9f9",
            height: "89%",
            paddingTop: "0px"
          }}
        >

          <Box
            sx={{
              position: "sticky",
              top: "0px",
              backgroundColor: "#f9f9f9",
              zIndex: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: "8px",
              borderBottom: "1px solid #d1d5db",
              padding: "10px"
            }}
          >

            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              WAN Profiles
            </Typography>
            { deviceInfo!= 'ap' && <AddButton onAddClick={handleCreateProfile} addLabel="+" maxWidth="32px" />}
          </Box>


          {/* Profile List Items */}
          {wanProfiles.map((profile) => (
            <Box
              key={profile.id}
              onClick={() =>
                handleProfileChange({ id: String(profile.id), name: profile.profileName })
              }
              sx={{
                padding: "7px 14px",
                borderRadius: "4px",
                border: "1.6px solid",
                borderColor:
                  selectedProfile?.id === profile.id ? "#5F5FFF" : "#E5E7EB", // Purple for selected, gray for others
                backgroundColor: "#fff",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#F3F4F6",
                  borderColor:
                    selectedProfile?.id === profile.id ? "#5F5FFF" : "#D1D5DB", // slightly darker on hover
                },
                transition: "all 0.2s ease"
              }}
            >
              <Typography
                variant="body2"
                // fontWeight={selectedProfile?.id === profile.id ? 600 : 400}
                sx={{ color: "#111827" }}
              >
                {profile.profileName}
              </Typography>
            </Box>

          ))}
        </Box>

        <Box sx={{ flex: 1, paddingLeft: 2, border: "1px solid #d1d5db", borderRadius: "4px", marginLeft: "16px", backgroundColor: "#fff", paddingTop: "0px" }} className="wan-tab-grid-container wantab-right-panel">
          <div className="wan-tab-grid">
            {wanProfiles.length > 0 && selectedProfile && (
              <>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3, mt: 1, maxWidth: "260px" }}>
                <Typography variant="body2" sx={{ color: "#6B7280", fontWeight: 500 }}>
                  Selected WAN Profile
                </Typography>

                {!isRenaming ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px 12px",
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: 500, flex: 1, fontSize: "14px", color: "#0F172A" }}
                    >
                      {selectedProfile?.profileName}
                    </Typography>

                    <EditIcon
                      onClick={() => {
                        setIsRenaming(true);
                        setTempProfileName(selectedProfile?.profileName || "");
                      }}
                      style={{
                        width: 16,
                        height: 16,
                        cursor: "pointer",
                        marginLeft: 8,
                        color: "#6B7280",
                      }}
                    />
                  </Box>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #D1D5DB",
                        borderRadius: "4px",
                        padding: "6px 10px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <input
                        type="text"
                        value={tempProfileName}
                        autoFocus
                        onChange={(e) => {
                          const value = e.target.value;
                          setTempProfileName(value);

                          const isDuplicate = wanProfiles.some(
                            (p) => p.profileName === value
                          );

                          setSaveDisabled(isDuplicate);
                        }}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#0F172A",
                        }}
                      />

                      {/* Save (✔) */}
                      <CheckIcon
                        onClick={() => {
                          if (saveDisabled) return;
                          handleProfileEdit({
                            id: String(selectedProfile?.id),
                            name: tempProfileName,
                          });
                          setIsRenaming(false);
                        }}
                        style={{
                          width: 18,
                          height: 18,
                          cursor: saveDisabled ? "not-allowed" : "pointer",
                          color: saveDisabled ? "#D1D5DB" : "#6B7280",
                          marginLeft: 8,
                          pointerEvents: saveDisabled ? "none" : "auto",
                        }}
                      />

                      {/* Cancel (✖) */}
                      <CloseIcon
                        onClick={() => { setIsRenaming(false); setSaveDisabled(false) }}
                        style={{
                          width: 18,
                          height: 18,
                          cursor: "pointer",
                          color: "#6B7280",
                          marginLeft: 6,
                        }}
                      />
                    </Box>
                    <span style={{ color: 'red', fontSize: '11px' }}>{saveDisabled ? 'Profile Name should be Unique.' : ''}</span>
                  </>
                )}
              </Box>
              </>

            )}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: "10px" }}>
              {/* <AddButton onAddClick={handleCreateProfile} addLabel="Add WAN Profile" maxWidth="220px" /> */}
              {selectedProfile && !selectedProfile?.sys_profile && (
                <Box
                  component="button"
                  onClick={() => setIsDeleteModalOpen(true)}
                  sx={{
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    p: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                  }}
                  title="Delete Profile"
                >
                  <Box component="img" src={DeleteIcon} alt="Delete" sx={{ width: 16, height: 18 }} />
                </Box>
              )}
            </Box>
          </div>

          {!isLoadingProfile ? (
            <AdvancedWANConfigurator
              key={`${selectedProfile?.id}-${localBondingData.length}`}
              bondingData={localBondingData}
              unusedLinks={unusedLinks}
              onUnusedLinksChange={handleUnusedLinksChange}
              onBondingChange={handleBondingChange}
              isRenaming={isRenaming}
              selectedRow={row}
            />
          ) : (
            <Typography variant="body2" sx={{ ml: 2, mt: 2 }}>
              Loading profile details...
            </Typography>
          )}
        </Box>
      </div>}
      {activeTab == 'ip_configuration' && <div>
        <Box my={0}>
          <NetworkTable
            data={tableData}
            columns={columns}
            showFilterBar
            onActionClick={handleActionClick}
          />
        </Box>
      </div>}
      {activeTab == 'policy_routes' && <div>
        <Box my={0}>
          <PolicyRoutes selectedRow={row} refreshIconClicked={refreshIconClicked} notifyConfigAction={notifyConfigAction} notifyConfigActionComplete={notifyConfigActionComplete} />
        </Box>
      </div>}

      {selectedProfile && (
        <DeleteWANProfileModal
          open={isDeleteModalOpen}
          onClose={() => { setIsDeleteModalOpen(false); setDeleteError(''); }}
          onConfirm={() => {
            handleDeleteProfile(selectedProfile.id);
          }}
          profileName={selectedProfile.profileName}
          errorMessage={deleteError}
        />
      )}
      {deviceLinkStatusLoading || geteAllWanInterfacesForAdvSettingsLoading || getIpConfigUpdateLoading ? (
        <CustomLoader
          showLoader={true}
          loadingText={"Please wait..."}
        />
      ) : null}

      <AddEditInterfaceModal
        open={isModalOpen}
        onClose={handleClosePopup}
        onSave={handleUpdateIpConfig}
        saveText={'Update'}
        disableSave={!isFormValid()}
        title={'Edit IP Configuration'}
        layout={[
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="Interface Name"
                    isInput
                    value={formData?.interface_type_tmp}
                    onChange={handleChange("interface_type_tmp")}
                    placeholder="Select Interface Name"
                    disabled={true}
                  />
                ),
                gridSize: 12,
              }
            ],
          },
          {
            columns: [
              {
                component: (
                  <Grid sx={{display: 'grid'}}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData?.proto || false}
                          onChange={handleChange("proto")}
                          size="small"
                        />
                      }
                      label={
                        <span style={{
                          fontFamily: 'Inter, sans-serif',
                          fontWeight: 500,
                          fontSize: '12px',
                          color: 'rgba(110, 112, 121, 1)'
                        }}>
                          DHCP
                        </span>
                      }
                    />
                    <span className="ip-status">
                      {formData?.proto ? "DHCP Enabled" : "Static IP"}
                    </span>
                  </Grid>
                ),
                gridSize: 12,
              }
            ],
          },
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="IP Address / Subnet Mask"
                    isInput
                    value={formData?.ipaddr}
                    onChange={handleChange("ipaddr")}
                    placeholder="Select IP Address / Subnet Mask"
                    disabled={formData?.proto}
                    error={ipError}
                  />
                ),
                gridSize: 12,
              }
            ],
          },
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="Gateway Address"
                    isInput
                    value={formData?.gateway}
                    onChange={handleChange("gateway")}
                    placeholder="Select Gateway Address"
                    disabled={formData?.proto}
                    error={gatewayError}
                  />
                ),
                gridSize: 12,
              }
            ],
          },
          {
            columns: [
              {
                component: (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {!_.isEmpty(getIpConfigUpdate) && getIpConfigUpdate.msg}
                  </span>
                ),
                gridSize: 12,
              }
            ],
          },
        ]}
      />
    </div>
  );

}

const mapStateToProps = (state: any) => ({
  getWanProfiles: state.authReducer.getWanProfiles,
  getWanProfileDetails: state.authReducer.getWanProfileDetails,
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
  geteAllWanInterfacesForAdvSettings: state.authReducer.geteAllWanInterfacesForAdvSettings,
  geteAllWanInterfacesForAdvSettingsLoading: state.authReducer.geteAllWanInterfacesForAdvSettingsLoading,
  getIpConfigUpdate: state.authReducer.getIpConfigUpdate,
  getIpConfigUpdateLoading: state.authReducer.getIpConfigUpdateLoading,
});

export default withRouter(
  connect(mapStateToProps, {
    getWanProfilesData,
    getWanProfileDetailsData,
    updateWanProfileData,
    createWanProfileData,
    getUnusedWanInterfacesData,
    deleteWanProfileData,
    getDeviceLinkStatusData,
    geteAllWanInterfacesForAdvSettingsData,
    getIpConfigUpdateData
  })(WANTab)
);
